import is from 'is_js';
import * as moment from 'moment';

export function validateDateOfBirth(date) {
    let inputStr = moment(date);

    const now = moment()
    let limit = moment('1900-01-01');

    if(inputStr.isSameOrAfter(limit) 
    && inputStr.isSameOrBefore(now)
    && moment(date, "YYYY-MM-DD", true).isValid()){
        return true;
    } else{
        return false;
    }
}

export function validateDay(str) {
    let inputStr = moment(str);
    let month = inputStr.month() + 1;
    let day = inputStr.date();

    if(month !== null && month != 'undefined'){
        return moment((month+"-"+day), "MM-DD", true).isValid();
    } else{
        if(parseInt(day) <= 31 && parseInt(day) > 0){
            return true;
        } else{
            return false;
        }
    }
    return false;
}

export function validateMonth(str) {
    let inputStr = moment(str);
    let month = inputStr.month();
    let day = inputStr.date();
    if(day !== null && day != 'undefined'){
        return validateDay(day, month);
    }
    return moment(str, "MM", true).isValid();
}

export function validateYear(str) {
    let inputStr = moment(str);
    let limit = moment('1900');
    let currentYear = moment().year();
    let inputYear = inputStr.year();

    if(inputStr.isSameOrAfter(limit) && moment(str, "YYYY", true).isValid()){
        //Note that moment.js will make a year by itself be slightly less than Jan 1 of that year so <= will allow 
        // the current year +1 to be valid. 
        if(inputYear < currentYear){
            return true;
        }
        return false;
    } else{
        return false;
    }
}

// FIXME Add real rules.
export function validatePassword(str) {
    // Length 8+
    if (str.length < 8 || str.length > 16) {
        return false;
    }
    
    var regularExpression = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\x20-\x2F, \x3A-\x40, \x5B-\x60, \x7B-\x7E]).{8,16}/;
    if (str.match(regularExpression)) {
        return true;
    }
    return false;
}

export function validateMedicareNumber(str) {
    var pattern = /^\d{9}$/;
    if(str.match(pattern))
    {
        return true;
    }
    return false;
    
}

export function validateRegNumber(str) {
    var pattern = /^[a-zA-Z\d]{6}$/;
    if(str.match(pattern)) {
        return true;
    }
    return false;
}

export function validateMedicareExpiry(str) {
    return moment(str, "MM/YY", true).isValid();
}

export function validateEmail(str) {
    let emailStr = str.toLowerCase();
    if (is.email(emailStr)) {
        return true;
    }
    return false;
}

export function validatePhoneNumber(str) {
    var pattern = /^[0-9]{0,10}$/;
    if (str.match(pattern)) {
        return true;
    }
    return false;
}

export function validatePostalCode(str) {
    if (is.caPostalCode(str)) {
        return true;
    }
    return false;
}

export function validateUsername(str){
    if(str.length <= 50 && str.length >= 6){
        return true;
    } else {
        return false;
    }
}

export function validateUsernameChars(str){
    let pattern = /^[A-Za-z0-9_.@-]*$/;

    if(str.match(pattern)){
        return true;
    } else {
        return false;
    }
}